import { motion, useAnimationControls, animate, useMotionValue, motionValue, useTransform, } from "framer-motion";
import { useEffect, useState, useContext, } from "react";
import axios from "axios";
import CookieContext from "../contexts/CookieContext";
import AppContext from "../contexts/AppContext";
import useSound from "use-sound";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import soundInRaffle from '../library/sounds/inRaffle.mp3';
import soundStop from '../library/sounds/stop.mp3';

import styled from "@emotion/styled";


const StyledButton = styled.button`
  width: 150px;
  color: ${({ disabled }) => disabled ? '#ffffff' : '#cccccc'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #000099)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`}
`;

const RetrieveButton = styled.button`
  width: 150px;
  color: ${({ disabled }) => disabled ? '#ffffff' : '#cccccc'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #520237)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`}
`;

const Guest = () => {
  const [playSoundInRaffle] = useSound(soundInRaffle);
  const [playSoundStop] = useSound(soundStop);

  // 抽選数字
  const [ selectedNumber, setSelectedNumber ] = useState(0);
  // 抽選中数字（小数点以下あり）
  const [ motionValueInRaffleNumber, setMotionValueInRaffleNumber ] = useState(useMotionValue(0));
  // 抽選中数字（小数点以下切り捨て）
  const [ inRaffleNumber, setInRaffleNumber ] = useState(useTransform(motionValueInRaffleNumber, Math.ceil));
  // ルーレットバーの初期表示位置
  const [ displayNumber, setDisplayNumber ] = useState(1);
  // 停止音を鳴らすかどうかの判定フラグ
  const [ playStopSound, setPlayStopSound ] = useState(true);
  const [ retrieveButtonDisabled, setRetrieveButtonDisabled ] = useState(false);
  const [ executeButtonDisabled, setExecuteButtonDisabled ] = useState(true);

  const { apiUserHost, } = useContext(AppContext);
  const { cookies } = useContext(CookieContext);
  const { apiHost } = useContext(AppContext);
  const basePath = 'roulette/';
  const [loading, setLoading] = useState(true);

  // const [disabled, setDisabled] = useState(true);
  const [updateDisabled, setUpdateDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);

  const [error, setError] = useState();

  const [dataId, setDataId] = useState();
  const [dataName, setDataName] = useState();
  const [roulettes, setRoulettes] = useState([]);
  const [rouletteId, setRouletteId] = useState();
  const [rouletteItems, setRouletteItems] = useState([]);
  const [dataIpAddr, setDataIpAddr] = useState();
  const [dataUserId, setDataUserId] = useState();

  const navs = ["", "About", "Contact"];
  const navsJ = ["ホーム", "アバウト", "連絡先"];

  // const [active, setActive] = useState(navs[0]);

  // ルーレット回転数（現在の数値より大きい数値になることを担保するために2以上の値を設定）
  let rouletteRoundCounter = 2;
  // 止まるまでの時間
  let initDuration = 3;
  const [duration, setDuration] = useState(initDuration);

  // 抽選数字の最大値
  let maxNumber = rouletteItems.length;

  // min, max間の整数を均等な期待値でランダムに抽出
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const handleRouletteStart = async() => {
    // ルーレット開始時にボタンを押せないようにし、停止時の音を鳴らす設定に更新
    setExecuteButtonDisabled(true);
    setRetrieveButtonDisabled(true);
    setPlayStopSound(true);
    setDuration(initDuration);
    // スタート位置設定（前回止まった位置をスタート位置とする）
    await motionValueInRaffleNumber.set(selectedNumber % maxNumber);
    
    // アイテム数×回転数+1～アイテム数×（回転数+1）の数字をランダムでget
    // 例：10アイテム、2回転の場合、21～30から抽選、3アイテム、4回転の場合、13～15から抽選
    await setSelectedNumber(randomNumberInRange(maxNumber * rouletteRoundCounter + 1, maxNumber * (rouletteRoundCounter + 1)));
  }

  const SoundCheck = async () => {
    if(inRaffleNumber.get() < motionValueInRaffleNumber.get()){
      // 次の数字になったら、音を鳴らす
      await playSoundInRaffle();
      // アイテム数+1の剰余を設定（例：アイテム数10場合、0～9ではなく、1～10の値を取得する）
      setDisplayNumber(parseInt((inRaffleNumber.get() - 1) % maxNumber + 1));
    } else if( motionValueInRaffleNumber.get() != 0 && inRaffleNumber.get() === selectedNumber){
      // 抽選数字なら音を鳴らして、停止音がなり続けるのを止める
      if(playStopSound){
        await playSoundStop();
        await setPlayStopSound(false);
      }
      // 抽選が終ったため、ボタンを有効にする
      await setDuration(0);
      setExecuteButtonDisabled(false);
      setRetrieveButtonDisabled(false);
    } else {
      console.log("motionValueInRaffleNumber.get():", motionValueInRaffleNumber.get());
    }
  }

  animate(motionValueInRaffleNumber, selectedNumber, {
    duration: duration,
    onUpdate: latest => [
      // // デバッグ用コンソールログ
      // console.log(
      //   'motionValueInRaffleNumber:', motionValueInRaffleNumber, 
      //   'inRaffleNumber:', inRaffleNumber,
      //   'displayNumber:', displayNumber,
      //   'inRaffleNumber:', inRaffleNumber.get(),
      //   ' buttonDisabled:', buttonDisabled,
      //   ' latest:', latest
      // ),
      SoundCheck(),
    ]
  });


  // データ更新用
  useEffect(() => {
    fetchRoulettes();
  }, [displayNumber]);

  // データ更新用
  useEffect(() => {
    // retrieveRoulette(127);
    retrieveRoulette(rouletteId);
    // fetchRoulettes();
  }, []);


  const fetchRoulettes = async () => {
    try {
      const response = await fetch(apiHost + basePath + 'noauth/');

      // fetch成功時、status200
      if (response.status === 200) {
        const data = await response.json();
        setRoulettes(data);
      } else {
        setError('エラー');
      }
      // setLoading(false);
    } catch (err) {
      console.log(err);
    }
  }
  
  const retrieveRoulette = async(pk) => {
    try {
      // setExecuteButtonDisabled(true);
      // setRetrieveButtonDisabled(true);
      const response = await fetch(`${apiHost}${basePath}noauth/${pk}/items`);

      // fetch成功時、status200
      if (response.status === 200) {
        const data = await response.json();
        setRouletteItems(data);
        setExecuteButtonDisabled(false);
        // document.getElementById('name').value = data.name;
        // setDataId(pk);
        // setDataName(data.name);
        // setRoulettes(data.name);
        // setDataIpAddr(data.ip_addr);
        // setDataUserId(data.user);
      } else {
        setError('エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      {Array.isArray(roulettes) ? roulettes.map((roulette, index) => {
        return (
          <>
            {roulette.id}:{roulette.title}
          </>
        )
      })
      : null
      }
      <div
      style={{padding: '10px', margin: '0 auto', width: '330px',
        background: 'linear-gradient(180deg, #000000, #000000', border: '1px solid #cccccc', color: '#cccccc',
        fontFamily: '"Noto Sans Math", sans-serif', fontWeight: 500, textAlign: 'left' }}>
        <div>
          {Array.isArray(rouletteItems) ? rouletteItems.map((rouletteItem, index) => {
            if(index < rouletteItems.length) {
                // 一致している項目は、緑か黄色で表示
              if(index + 1 === displayNumber){
                // 停止数字だった場合は緑、そうでなければ黄色
                if(selectedNumber === inRaffleNumber.get()) {
                  return <div key={index + 1} style={{ backgroundColor: '#57f727', color: '#000000', }}>{index + 1}:{rouletteItem.title}</div>;
                } else {
                  return <div key={index + 1} style={{ backgroundColor: '#ffff00', color: '#000000', }}>{index + 1}:{rouletteItem.title}</div>;
                }
              } else {
                return <div key={index + 1}>{index + 1}:{rouletteItem.title}</div>;
              }
            }})
            : null
          }
        </div>
      </div>
      <div
        style={{padding: '10px', margin: '0 auto', width: '330px',
        background: 'linear-gradient(180deg, #000000, #000000', border: '1px solid #cccccc', color: '#cccccc',
        fontFamily: '"Noto Sans Math", sans-serif', fontWeight: 500, textAlign: 'left' }}>
        <div>
        {Array.isArray(roulettes)
          ? roulettes.map((roulette, index) => {
            return <RetrieveButton key={index} disabled={retrieveButtonDisabled} onClick={() => {retrieveRoulette(roulette.id)}}>【{roulette.id}】{roulette.title}</RetrieveButton>
          })
          : null
        }
        </div>
      </div>
      <div>
        <StyledButton disabled={executeButtonDisabled} onClick={() => handleRouletteStart()}>
          抽選
        </StyledButton>
      </div>
      <div className="bd-callout bd-callout-warning" style={{ margin: "5px" }}>
        <Box>
          <Grid container spacing={2}>
            <Grid size={3}>motionValueInRaffleNumber</Grid>
            <Grid size={3}>inRaffleNumber</Grid>
            <Grid size={3}>selectedNumber</Grid>
            <Grid size={3}>displayNumber</Grid>
            <Grid size={3}>{motionValueInRaffleNumber.get()}</Grid>
            <Grid size={3}>{inRaffleNumber.get()}</Grid>
            <Grid size={3}>{selectedNumber}</Grid>
            <Grid size={3}>{displayNumber}</Grid>
          </Grid>
        </Box>
      </div>
    </>
  )
}
export default Guest
